export const isNumeric = function (str: string | number): boolean {
    if (typeof str === 'number') return true;
    if (typeof str !== 'string') return false; // we only process strings!
    return /^[0-9]+$/.test(str);
};
